module.exports = __webpack_public_path__ + "static/media/shop-vip-divider-glows.785a312c.png";